import type { CSSProperties } from 'react';

/**
 * Layout 본문(데스크톱 1280px) 안에서 학생 홈(ClassStudentHome)과 같은 가로 여백 규칙.
 * - 데스크톱: 추가 가로 패딩 없음
 * - 모바일(레이아웃 isMobile): 16px
 */
export function getMakecodeArcadePageRootStyle(
  isMobile: boolean,
  extra?: CSSProperties
): CSSProperties {
  return {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    margin: 0,
    padding: isMobile ? '16px' : '0',
    minHeight: 0,
    ...extra,
  };
}
